import _extends from "@babel/runtime/helpers/esm/extends";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React from 'react';
import PropTypes from 'prop-types';
import invariant from 'invariant';
import { getRandomID } from "../../../lib/utils";
import { Radio } from "../../Radio";
import { createPropsGetter } from "../../../lib/createPropsGetter";
import { FocusTrap } from "../../../internal/FocusTrap";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { cx } from "../../../lib/theming/Emotion";
import { styles } from "../RadioGroup.styles";
import { Prevent } from "../Prevent";
export var RadioGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(RadioGroup, _React$Component);

  function RadioGroup(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.theme = void 0;
    _this.node = void 0;
    _this.name = getRandomID();
    _this.getProps = createPropsGetter(RadioGroup.defaultProps);

    _this.getValue = function () {
      return _this.isControlled() ? _this.props.value : _this.state.activeItem;
    };

    _this.getName = function () {
      return _this.props.name || _this.name;
    };

    _this.isControlled = function () {
      return _this.props.value != null;
    };

    _this.handleSelect = function (value) {
      if (!_this.isControlled()) {
        _this.setState({
          activeItem: value
        });
      }

      if (_this.props.onValueChange) {
        _this.props.onValueChange(value);
      }
    };

    _this.renderRadio = function (itemValue, data, index) {
      var _cx;

      var itemProps = {
        key: typeof itemValue === 'string' || typeof itemValue === 'number' ? itemValue : index,
        className: cx((_cx = {}, _cx[styles.item(_this.theme)] = true, _cx[styles.itemFirst()] = index === 0, _cx[styles.itemInline()] = !!_this.props.inline, _cx))
      };
      return /*#__PURE__*/React.createElement("span", itemProps, /*#__PURE__*/React.createElement(Radio, {
        value: itemValue
      }, _this.getProps().renderItem(itemValue, data)));
    };

    _this.ref = function (element) {
      _this.node = element;
    };

    _this.state = {
      activeItem: _this.props.defaultValue
    };
    return _this;
  }

  var _proto = RadioGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      activeItem: this.getValue(),
      onSelect: this.handleSelect,
      name: this.getName(),
      disabled: this.props.disabled,
      error: this.props.error,
      warning: this.props.warning
    };
  };

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this2.theme = theme;
      return _this2.renderMain();
    });
  };

  _proto.renderMain = function renderMain() {
    var _this$props = this.props,
        width = _this$props.width,
        onMouseLeave = _this$props.onMouseLeave,
        onMouseOver = _this$props.onMouseOver,
        onMouseEnter = _this$props.onMouseEnter,
        onBlur = _this$props.onBlur;
    var style = {
      width: width != null ? width : 'auto'
    };
    var handlers = {
      onMouseOver: onMouseOver,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    };
    return /*#__PURE__*/React.createElement(CommonWrapper, this.props, /*#__PURE__*/React.createElement(FocusTrap, {
      onBlur: onBlur
    }, /*#__PURE__*/React.createElement("span", _extends({
      ref: this.ref,
      style: style,
      className: styles.root()
    }, handlers), this.renderChildren())));
  }
  /**
  * @public
  */
  ;

  _proto.focus = function focus() {
    var node = this.node;

    if (!node) {
      return;
    }

    var radio = node.querySelector('input[type="radio"]:checked'); // If no checked radios, try get first radio

    if (!radio || radio.disabled) {
      radio = node.querySelector('input[type="radio"]:not([disabled])');
    }

    if (radio) {
      radio.focus();
    }
  };

  _proto.renderChildren = function renderChildren() {
    var _this$props2 = this.props,
        items = _this$props2.items,
        children = _this$props2.children;
    invariant(!items && children || items && !children, 'Either items or children must be passed, not both');
    return items ? mapItems(this.renderRadio, items) : children;
  };

  return RadioGroup;
}(React.Component);
RadioGroup.__KONTUR_REACT_UI__ = 'RadioGroup';
RadioGroup.childContextTypes = {
  error: PropTypes.bool,
  name: PropTypes.string,
  warning: PropTypes.bool,
  disabled: PropTypes.bool,
  activeItem: PropTypes.any,
  onSelect: PropTypes.func
};
RadioGroup.propTypes = {
  /**
  * Может быть использовано, если не передан параметр `items`
  *
  * `children` может содержать любую разметку с компонентами Radio.
  * Каждому компоненту Radio нужно указать параметр `value`, такого же типа
  * как и параметр `value` самой радиогруппы.
  *
  * Значения активного элемента сравниваются по строгому равенству `===`
  */
  children: PropTypes.node,

  /**
  * Значение по умолчанию. Должно быть одним из значений дочерних радиокнопок
  * или значей из параметра `items`
  */
  defaultValue: PropTypes.any,

  /**
  * Дизейблит все радиокнопки
  */
  disabled: PropTypes.bool,

  /**
  * Переводит все радиокнопки в состоянии ошибки
  */
  error: PropTypes.bool,

  /**
  * Выравнивает элементы в строку. Не работает с `children`
  */
  inline: PropTypes.bool,

  /**
  * Может быть использовано, если не передан параметр `children`
  *
  * Массив параметров радиокнопок. Может быть типа `Array<Value>` или
  * `Array<[Value, Data]>`, где тип `Value` — значение радиокнопки, а `Data`
  * — значение которое будет использовано вторым параметром в `renderItem`.
  * Если тип `items: Array<Value>`, то он будет приведен к типу
  * `Array<[Value, Value]>`
  */
  items: PropTypes.any,

  /**
  * Аттрибут name для вложенных радиокнопок. Если не указан, то сгенерируется
  * случайное имя по алгоритму
  * [uuid v1](https://github.com/kelektiv/node-uuid#version-1)
  */
  name: PropTypes.string,

  /**
  * Метод отрисовки контента радиокнопки. Не работает с `children`.
  *
  * Принимает два аргумента: `(value: Value, data: Data) => React.Node`
  */
  renderItem: PropTypes.func,

  /**
  * Значение радиогруппы. Должно быть одним из значений радиокнопок.
  * Если не указано, то компонент будет работать, как неконтроллируемый
  */
  value: PropTypes.any,

  /**
  * Переводит все радиокнопки в состоянии предупреждения
  */
  warning: PropTypes.bool,

  /**
  * Ширина радиогруппы. Не работает с `children`
  */
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
  * Обработчик события при переключении радиокнопок.
  * Имеет тип
  * `(value: Value) => any`
  */
  onValueChange: PropTypes.func,
  onBlur: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onMouseOver: PropTypes.func
};
RadioGroup.defaultProps = {
  renderItem: renderItem
};
RadioGroup.Prevent = Prevent;

function renderItem(_value, data) {
  return data;
}

function mapItems(fn, items) {
  var result = [];
  var index = 0;

  for (var _iterator = _createForOfIteratorHelperLoose(items), _step; !(_step = _iterator()).done;) {
    var entry = _step.value;

    var _normalizeEntry = normalizeEntry(entry),
        _value2 = _normalizeEntry[0],
        _data = _normalizeEntry[1];

    result.push(fn(_value2, _data, index));
    ++index;
  }

  return result;
}

function normalizeEntry(entry) {
  if (!Array.isArray(entry)) {
    return [entry, entry];
  }

  return entry;
}